import styled from "styled-components";
import { HomepageHeaderArenaBadgeDefaultBox } from "./home-page-header-arena-badge.default.box";

export const HomepageHeaderArenaBadgeMrGreenBox = styled(HomepageHeaderArenaBadgeDefaultBox)`
    font-size: 1.2rem;
    color: ${({theme}) => theme.colors.textContrast};
    padding: 0.1rem 0.5rem;
`;
